module.exports = __webpack_public_path__ + "img/MFC8800.a1ec71cc.png";